var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.element.hasVisibleErrors
    ? _c(
        "div",
        {
          class: _vm.element.cssError,
          attrs: {
            role: "alert",
            "aria-live": "polite",
            id: _vm.element.id + "_errors",
          },
        },
        _vm._l(_vm.element.errors, function (error, index) {
          return _c(_vm.element.survey["questionErrorComponent"], {
            key: "error_" + index,
            tag: "component",
            attrs: {
              element: _vm.element,
              errorKey: "error_" + index,
              error: error,
              cssClasses: _vm.element.cssClasses,
            },
          })
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }